import { Named } from './named';
import { Tag } from '../tags/tags';
import { OwnedSet } from './ownedset';

export abstract class TaggableNamed extends Named {
    public tags = OwnedSet.create<Tag>();
    // holds the tags that are not strings.
    public malformedTags = OwnedSet.create<Tag>();
}
